
import Cookies from "js-cookie";

const checkEvery = 5000;
const domains = [
  location.hostname,
  ".remove.bg",
  "beta.remove.bg",
  "www.remove.bg",
]

window.setInterval(() => {
  domains.forEach(domain => {
    const generalDeletion = `_ga_C907D2DWK7=;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    const domainSpecificDeletion = `_ga_C907D2DWK7=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
    document.cookie = generalDeletion;
    document.cookie = domainSpecificDeletion;
  });
}, checkEvery);

